/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandXing = createReactComponent("brand-xing", "IconBrandXing", [
  ["path", { d: "M16 21l-4 -7l6.5 -11", key: "svg-0" }],
  ["path", { d: "M7 7l2 3.5l-3 4.5", key: "svg-1" }]
]);

export { IconBrandXing as default };
//# sourceMappingURL=IconBrandXing.js.map
